import React from 'react';
import {Basic} from '@packages/systems/core/plugins';
import {iconName, typeName, qualify} from '@packages/systems/wfdl-Qualified';
import {
  Atom,
  withSystem,
  Plugins,
  type AtomRender,
} from '@packages/systems/wfdl';
import {SHARED_ANCHOR_NODE_CONSTRAINTS_DESCENDANTS} from '@packages/systems/core/constants/SharedConstraintRules';
import {maybeAddOpen} from './utils';
import {
  TList,
  TRecord,
  TElement,
  TTypeConstructor,
  TText,
} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {EVENT_IDS_ATOM_FIELD} from '@packages/systems/optimization/constants';

const Link = Atom.getConfigShape(Basic.atoms.Link).render as AtomRender;

const NavbarLink = Atom.createRender(({classes, ...rest}) => {
  const linkProps = {
    classes: classes
      .push('w-nav-link')
      .update(maybeAddOpen(rest.context)('w--nav-link-open')),
    ...rest,
  } as const;
  return <Link {...linkProps} />;
});

const config = createDevlinkAtom({
  displayName: 'Nav Link',
  constraints: {
    descendants: SHARED_ANCHOR_NODE_CONSTRAINTS_DESCENDANTS,
    ancestors: [
      {
        is: 'NavbarWrapper',
        rule: 'ExactlyOne',
      },
    ],
  },
  // We don't want to automatically show the `NavbarWrapper` Settings when a
  // `NavbarLink` is selected based on constraints.
  hideAncestorSettings: true,
  icon: {
    value: qualify(Plugins.name('Basic'), iconName('Link')),
    type: 'Component',
  },
  showEmpty: true,
  render: NavbarLink,
  fields: {
    navbar: withSystem(
      {private: true},
      TRecord({
        type: TText,
      })
    ),
    link: withSystem(
      {
        label: 'Link',
        isBindable: true,
        defaultValue: {mode: 'external'},
        isLocalizable: true,
      },
      TTypeConstructor(qualify(Plugins.name('Basic'), typeName('Link')))
    ),
    children: withSystem({label: 'Text', isBindable: true}, TList(TElement)),
    eventIds: EVENT_IDS_ATOM_FIELD,
  },
  autoEngagementTrackingAttribute: true,
});

export default config;
